import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Unit } from '../../models/unit';
import { ModalService } from '../../../lib/services/modal.service';
import {
  UploadImageModalComponent,
  UploadImageModel,
  UploadImageType,
} from '../../../components/upload-image-modal/upload-image-modal.component';
import { take } from 'rxjs/operators';

class ImageSnippet {
  pending: boolean = false;
  status: string = 'init';

  constructor(public src?: any, public file?: File) {}
}

@Component({
  selector: 'mj-unit-logo',
  templateUrl: 'unit-logo.component.html',
  styleUrls: ['unit-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnitLogoComponent implements OnChanges {
  public selectedFile;
  @Input() unit: Unit;
  @Output() update: EventEmitter<Unit> = new EventEmitter<Unit>();

  fallbackImg;

  constructor(
    private _snackBar: MatSnackBar,
    private modalService: ModalService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.unit && this.unit) {
      this.selectedFile = new ImageSnippet(this.unit.logo_url);
    }
  }

  get imageSrc() {
    return this.selectedFile && this.selectedFile.file
      ? this.selectedFile.file
      : this.selectedFile.src;
  }

  getFallback(imgElem) {
    if (this.fallbackImg) {
      imgElem.src = this.fallbackImg;
    }
  }

  onUploadImage() {
    this.modalService
      .appendComponentToBody(
        UploadImageModalComponent,
        new UploadImageModel(UploadImageType.UNIT_LOGO_TYPE, null)
      )
      .pipe(take(1))
      .subscribe(res => {
        if (res) {
          this.update.emit({
            ...this.unit,
            logo_media_id: res.id,
            logo_url: res.image_thumbnail,
          });
          this._snackBar.open('Image uploaded successfully', null, {
            duration: 3000,
          });
        }
      });
  }
}
